import { P2, P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  * {
    text-align: left;
  }

  ${FlexColumn}:first-child {
    padding: 24px 12px;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    overflow-y: scroll;

    ${QUERIES.largeTabletAndUp} {
      padding: 32px;
    }
  }
`;

export const ImageWrapper = styled(FlexColumn).attrs({
  alignItems: 'center',
  width: '604px',
})`
  display: none;
  background-color: ${themeStyle.varInkSuperLight};
  justify-content: center;
  height: 100%;

  ${QUERIES.largeTabletAndUp} {
    display: flex;
  }
`;

export const AccountButtonWrapper = styled.div`
  border: 1px solid ${themeStyle.varInkLight};
  border-radius: 8px;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  gap: 8px;

  div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const IconButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  ${P2} {
    color: ${themeStyle.varInkMedium};
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 40px;
`;

export const TruncatedTitleWrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
`;

export const UpgradePlanButton = styled(P3)`
  font-size: inherit;
  line-height: inherit;
  display: inline;
`;
